import { ArrowBack, ExpandMore, Close as CloseIcon } from '@mui/icons-material'
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  Button,
  DialogContent,
  Dialog,
  DialogTitle,
  IconButton
} from '@mui/material'
import { LabelField } from 'components'
import { VehicleNeedsClusterRemovedDetailsDto } from 'dtos/vehicleNeedsClusterRemovedDetailsDto'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

interface NeedsClusterRemovedHeroCardProps {
  vehicle: VehicleNeedsClusterRemovedDetailsDto
}

export default function NeedsClusterRemovedHeroCard({ vehicle }: NeedsClusterRemovedHeroCardProps) {
  const navigate = useNavigate()

  const [viewDetailsDialogOpen, setViewDetailsDialogOpen] = useState<boolean>(false)

  const handleViewDetailsOpen = () => {
    setViewDetailsDialogOpen(true)
  }

  const handleViewDetailsClose = () => {
    setViewDetailsDialogOpen(false)
  }

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='flex-start'>
          <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
            <Grid item xs={12} sm='auto' container alignItems='center' spacing={0}>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  {vehicle.vin} VIN
                </Typography>
              </Grid>
            </Grid>

            <Grid item xs={12} sm='auto' container spacing={1}>
              <Grid item>
                <Button onClick={() => navigate('/to-do-list')} color='primary' startIcon={<ArrowBack />} variant='text'>
                  Back
                </Button>
              </Grid>

              <Grid item sx={{ alignSelf: 'stretch' }}>
                <Divider orientation='vertical' />
              </Grid>

              <Grid item>
                <Button onClick={handleViewDetailsOpen} color='primary' endIcon={<ExpandMore />} variant='text'>
                  View Details
                </Button>
              </Grid>

              <Dialog open={viewDetailsDialogOpen} onClose={handleViewDetailsClose} maxWidth='md'>
                <DialogTitle>
                  Vehicle Details
                  <IconButton
                    aria-label='close'
                    onClick={handleViewDetailsClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: theme => theme.palette.grey[500]
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <LabelField label='VIN:' value={vehicle.vin} />
                    </Grid>
                    <Grid item xs={12}>
                      <LabelField label='Buyer:' value={vehicle.buyerCompany?.name} />
                    </Grid>
                    <Grid item xs={12}>
                      <LabelField label='Exporter:' value={vehicle.exporterCompany?.name} />
                    </Grid>
                    <Grid item xs={12}>
                      <LabelField label='Year:' value={vehicle.year} />
                    </Grid>
                    <Grid item xs={12}>
                      <LabelField label='Make:' value={vehicle.make} />
                    </Grid>
                    <Grid item xs={12}>
                      <LabelField label='Model:' value={vehicle.model} />
                    </Grid>
                    <Grid item xs={12}>
                      <LabelField label='Importer Stock#:' value={vehicle.importerStockNumber} />
                    </Grid>
                  </Grid>
                </DialogContent>
              </Dialog>
            </Grid>
          </Grid>

          {/* <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Exporter/Buyer' value={vehicle.exporterCompany?.name} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Year' value={vehicle.year} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Make' value={vehicle.make} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Model' value={vehicle.model} />
          </Grid>

          <Grid item xs={12} sm={3}>
            <LabelField label='Importer Stock #' value={vehicle.importerStockNumber} />
          </Grid> */}
        </Grid>
      </CardContent>
    </Card>
  )
}
